import { useMemo } from 'react'

import {
  Params,
  CustomPaginationQueryKeys,
  DEFAULT_PAGINATION_KEYS,
} from '../utils/params'

import { useFilters } from '@/context/filterContext'
import { useQueryParams } from '@/context/queryParamsContext'

import { PaginationInput } from 'types/api.graphql'

export const useRoutePagination = (pageSize = 20) => {
  const { routeFilters } = useFilters()

  const data = routeFilters?.pagination

  const pagination = useMemo<PaginationInput>(() => {
    if (!data) return { limit: pageSize, offset: 0 }

    const size = data.pageSize || pageSize

    return {
      limit: size,
      offset: Math.max(0, Math.floor((data.current - 1) * size)),
    }
  }, [data, pageSize])

  return pagination
}

export const useQueryRoutePagination = (
  pageSize = 20,
  customQueryKeys?: CustomPaginationQueryKeys
) => {
  const { params } = useQueryParams<Params.Pagination>()

  const sizeKey = customQueryKeys?.pagesize ?? DEFAULT_PAGINATION_KEYS.pageSize
  const pageKey = customQueryKeys?.page ?? DEFAULT_PAGINATION_KEYS.page

  const size = params[sizeKey] ?? pageSize
  const page = params[pageKey]

  const pagination = useMemo<PaginationInput>(() => {
    return {
      limit: size,
      offset: Math.max(0, Math.floor((page - 1) * size)),
    }
  }, [size, page])

  return pagination
}
